export function scrollToInput(event: any) {
  const input = event.target;
  setTimeout(() => {
    input.scrollIntoView({
      behavior: "auto",
      block: "center",
    });
  }, 500);
}

export function debounce<T extends (...args: any[]) => void>(
  fn: T,
  delay = 300
): (...args: Parameters<T>) => void {
  let timer: ReturnType<typeof setTimeout> | null = null;

  return function (...args: Parameters<T>) {
    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}

export function convertToMiliseconds(
  time?: number,
  unit?: "minutes" | "seconds"
) {
  if (!time || !unit) return 0;
  if (unit === "minutes") return time * 60 * 1000;
  return time * 1000;
}
